import axios from 'axios';
import { createAccountRedirectUrl, runtimeConfig } from './config/runtime';

const instance = axios.create({ baseURL: runtimeConfig.apiBaseUrl });

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      localStorage.removeItem('token');
      localStorage.removeItem('tokenExpiration');
      
      window.location.href = createAccountRedirectUrl('/logout');
      
      return new Promise(() => {});
    }
    return Promise.reject(error);
  }
);

export default instance;